import React, { useRef, useState, useEffect, useCallback } from "react";

const DATA = [
  {
    name: "Express Tribune",
    headline:
      "Pakistani crypto expert Waqar Zaka wins global TradFi competition.",
    links: [
      {
        label: "Website",
        href: "https://tribune.com.pk/story/2620572/pakistani-crypto-expert-waqar-zaka-wins-global-tradfi-competition",
      },
      // {
      //   label: "Facebook",
      //   href: "https://www.facebook.com/share/p/17qXEYPXNb/",
      // },
      // {
      //   label: "Instagram",
      //   href: "https://www.instagram.com/pakobserver/p/DbS8kcSis8a/?hl=en",
      // },
    ],
  },
  {
    name: "Pakistan Observer",
    headline:
      "Crypto Expert Waqar Zaka Wins Global Competition, Receives 2026 Mercedes G-Wagon in Dubai.",
    links: [
      {
        label: "Website",
        href: "https://pakobserver.net/crypto-expert-waqar-zaka-wins-global-competition-receives-2026-mercedes-g-wagon-in-dubai/",
      },
      {
        label: "Facebook",
        href: "https://www.facebook.com/share/p/17qXEYPXNb/",
      },
      {
        label: "Instagram",
        href: "https://www.instagram.com/pakobserver/p/DbS8kcSis8a/?hl=en",
      },
    ],
  },
  {
    name: "The Nation",
    headline:
      "Crypto expert Waqar Zaka wins global competition, receives 2026 Mercedes G-Wagon in Dubai.",
    links: [
      {
        label: "Website",
        href: "https://www.nation.com.pk/27-Jul-2026/crypto-expert-waqar-zaka-wins-global-competition-receives-2026-mercedes-g-wagon-dubai",
      },
      {
        label: "Facebook",
        href: "https://www.facebook.com/thenationdaily/posts/pfbid02JeEU12UfXJd3qPJDnpSuqGkLfqwV74HoFt8TLzRMwA8Sn1K7A4geFka9Xx869WKHl",
      },
      {
        label: "Instagram",
        href: "https://www.instagram.com/thenation_pk/p/DbTXMFPFRZn/",
      },
    ],
  },
  {
    name: "The Current",
    headline:
      "Crypto expert Waqar Zaka wins global TradFi competition, receives 2026 Mercedes G-Wagon in Dubai.",
    links: [
      {
        label: "Website",
        href: "https://thecurrent.pk/crypto-expert-waqar-zaka-wins-global-tradfi-competition-receives-2026-mercedes-g-wagon-in-dubai/",
      },
      {
        label: "Facebook",
        href: "https://www.facebook.com/thecurrentpk/posts/pfbid0NE4UwvdweHJGgpJZQAmGerDpYQb5yQZAv4spqxRimBXCznnFRDq3SrBawXzNdbgKl",
      },
      {
        label: "X",
        href: "https://x.com/TheCurrentPK/status/2081705045511508257",
      },
      { label: "Instagram", href: "https://www.instagram.com/p/DbS2EWbDZzd/" },
    ],
  },
  {
    name: "24 News HD",
    headline:
      "Waqar Zaka wins global trading contest, bags 2026 Mercedes G-Wagon.",
    links: [
      {
        label: "Website",
        href: "https://www.24newshd.tv/27-Jul-2026/waqar-zaka-wins-global-trading-contest-bags-2026-mercedes-g-wagon",
      },
      {
        label: "Facebook",
        href: "https://www.facebook.com/24NewsHD.tv/posts/pfbid02FBcZnj2g7HTjkmfcz6ozq5dcDnLkjEWFsgHWdXVgbTfgEQSm1tLqmRKz4T1WmoVVl",
      },
      { label: "Instagram", href: "https://www.instagram.com/p/DbTEa6UDM_1/" },
    ],
  },
  {
    name: "Daily Pakistan",
    headline:
      "Crypto Expert Waqar Zaka Wins Global Competition, Receives 2026 Mercedes G-Wagon in Dubai.",
    links: [
      {
        label: "Website",
        href: "https://en.dailypakistan.com.pk/27-Jul-2026/crypto-expert-waqar-zaka-wins-global-competition-receives-2026-mercedes-g-wagon-in-dubai",
      },
      {
        label: "Facebook",
        href: "https://www.facebook.com/share/p/1PCSkQixP2/",
      },
      { label: "Instagram", href: "https://www.instagram.com/p/DbS5pz3iHyf/" },
    ],
  },
  {
    name: "ProPakistani",
    headline:
      "Crypto expert Waqar Zaka wins global competition, receives 2026 Mercedes G-Wagon in Dubai.",
    links: [
      { label: "Website", href: "https://propakistani.pk/?p=1054386" },
      {
        label: "Facebook",
        href: "https://www.facebook.com/ProPakistani/posts/pfbid025DnPNQj877mYBp2du7SGRSKgTJyL4jxyjXq5hB4XMK1C19n4QQF2mRHXipFC3tGBl",
      },
      {
        label: "X",
        href: "https://x.com/ProPakistaniPK/status/2081693225996398963",
      },
      {
        label: "Instagram",
        href: "https://www.instagram.com/pro_pakistani/p/DbSyaiwjnV7/",
      },
    ],
  },
];

const AUTOPLAY_SECONDS = 4;

export default function AwardWinningCarousel() {
  const scrollerRef = useRef(null);
  const [activeIdx, setActiveIdx] = useState(0);
  const pausedRef = useRef(false);

  const getStep = useCallback(() => {
    const el = scrollerRef.current;
    if (!el || !el.children[0]) return 394;
    const a = el.children[0];
    const b = el.children[1];
    if (b)
      return b.getBoundingClientRect().left - a.getBoundingClientRect().left;
    return a.getBoundingClientRect().width;
  }, []);

  const goTo = useCallback(
    (i) => {
      const el = scrollerRef.current;
      if (!el) return;
      el.scrollTo({ left: getStep() * i, behavior: "smooth" });
    },
    [getStep],
  );

  const advance = useCallback(() => {
    const el = scrollerRef.current;
    if (!el) return;
    if (el.scrollLeft + el.clientWidth >= el.scrollWidth - 4) {
      el.scrollTo({ left: 0, behavior: "smooth" });
    } else {
      el.scrollBy({ left: getStep(), behavior: "smooth" });
    }
  }, [getStep]);

  const handleScroll = useCallback(() => {
    const el = scrollerRef.current;
    if (!el) return;
    const i = Math.round(el.scrollLeft / getStep());
    setActiveIdx(i);
  }, [getStep]);

  useEffect(() => {
    const timer = setInterval(() => {
      if (!pausedRef.current) advance();
    }, AUTOPLAY_SECONDS * 1000);
    return () => clearInterval(timer);
  }, [advance]);

  return (
    <section className="awt-section">
      <div className="awt-wrap">
        <div className="awt-head">
          <div>
            {/* <div className="awt-eyebrow">As Seen In The Media</div> */}
            <h2 className="awt-title">
              WELCOME TO THE <span>AWARD WINNING</span> TRADING TEAM
            </h2>
            <p className="awt-sub">
              Pakistan's leading outlets covered Waqar Zaka winning the global
              trading competition and being awarded a 2026 Mercedes G-Wagon in
              Dubai. Read the coverage below.
            </p>
          </div>
          <div className="awt-nav">
            <button
              className="awt-btn awt-btn--prev"
              aria-label="Previous"
              onClick={() => {
                const el = scrollerRef.current;
                if (el) el.scrollBy({ left: -getStep(), behavior: "smooth" });
              }}
            >
              &#8592;
            </button>
            <button
              className="awt-btn awt-btn--next"
              aria-label="Next"
              onClick={() => {
                const el = scrollerRef.current;
                if (el) el.scrollBy({ left: getStep(), behavior: "smooth" });
              }}
            >
              &#8594;
            </button>
          </div>
        </div>

        <div
          className="awt-scroller"
          ref={scrollerRef}
          onScroll={handleScroll}
          onMouseEnter={() => {
            pausedRef.current = true;
          }}
          onMouseLeave={() => {
            pausedRef.current = false;
          }}
        >
          {DATA.map((item, idx) => (
            <article className="awt-card" key={idx}>
              <div className="awt-masthead">
                <div className="awt-kicker">
                  <span>In The News</span>
                  <span>Vol. 2026</span>
                </div>
                <div className="awt-nameplate">{item.name}</div>
                <div className="awt-feature">
                  &#9733;&nbsp;&nbsp;Award-Winning Feature&nbsp;&nbsp;&#9733;
                </div>
              </div>
              <div className="awt-body">
                <span className="awt-tag">Media Coverage</span>
                <h3 className="awt-outlet">{item.name}</h3>
                <p className="awt-headline">{item.headline}</p>
                <div className="awt-links">
                  {item.links.map((l, li) => (
                    <a
                      key={li}
                      className="awt-chip"
                      href={l.href}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {l.label} <span className="awt-arr">&#8599;</span>
                    </a>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="awt-dots">
          {DATA.map((_, i) => (
            <button
              key={i}
              className={`awt-dot${i === activeIdx ? " is-active" : ""}`}
              aria-label={`Go to slide ${i + 1}`}
              onClick={() => goTo(i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
